(() => {
  function init() {
    const menu = document.getElementById('pdp-mobile-menu');
    if (!menu || menu.dataset.ready) return;
    menu.dataset.ready = 'true';
    const trigger = document.getElementById('pdp-hamburger');
    const backdrop = document.getElementById('pdp-mobile-menu-backdrop');
    const close = document.getElementById('pdp-mobile-close');
    const script = document.querySelector('script[src*="zenx-header.js"]');
    const labels = script.dataset;
    let previousOverflow = '';
    function setMenu(open) {
      if (open) previousOverflow = document.body.style.overflow;
      menu.classList.toggle('active', open);
      backdrop.classList.toggle('active', open);
      trigger.classList.toggle('active', open);
      trigger.setAttribute('aria-expanded', String(open));
      menu.inert = !open;
      document.body.style.overflow = open ? 'hidden' : previousOverflow;
      (open ? close : trigger).focus();
    }
    trigger.addEventListener('click', () => setMenu(!menu.classList.contains('active')));
    close.addEventListener('click', () => setMenu(false));
    backdrop.addEventListener('click', () => setMenu(false));
    menu.addEventListener('click', e => { if (e.target.closest('a')) setMenu(false); });
    menu.addEventListener('keydown', e => {
      if (e.key !== 'Tab') return;
      const nodes = [...menu.querySelectorAll('a[href],button')].filter(n => n.getClientRects().length);
      const first = nodes[0], last = nodes[nodes.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    const dropdowns = [...document.querySelectorAll('.pdp-nav-dropdown-wrapper')];
    dropdowns.forEach(wrapper => {
      const button = wrapper.querySelector('button');
      const set = open => { wrapper.classList.toggle('active', open); button.setAttribute('aria-expanded', String(open)); };
      button.addEventListener('click', () => {
        const open = !wrapper.classList.contains('active');
        dropdowns.forEach(w => { w.classList.remove('active'); w.querySelector('button').setAttribute('aria-expanded','false'); });
        set(open);
        if (!open) button.blur();
      });
      wrapper.addEventListener('mouseenter', () => set(true));
      wrapper.addEventListener('mouseleave', () => { if (!wrapper.contains(document.activeElement)) set(false); });
      wrapper.addEventListener('focusin', () => set(true));
      wrapper.addEventListener('focusout', e => { if (!wrapper.contains(e.relatedTarget)) set(false); });
    });
    document.addEventListener('click', e => dropdowns.forEach(w => {
      if (!w.contains(e.target)) { w.classList.remove('active'); w.querySelector('button').setAttribute('aria-expanded','false'); }
    }));
    document.addEventListener('keydown', e => {
      if (e.key !== 'Escape') return;
      if (menu.classList.contains('active')) setMenu(false);
      dropdowns.forEach(w => { w.classList.remove('active'); w.querySelector('button').setAttribute('aria-expanded','false'); if(w.contains(document.activeElement)) document.activeElement.blur(); });
    });
    matchMedia('(min-width:769px)').addEventListener('change', e => {if(e.matches && menu.classList.contains('active')) setMenu(false);});
    const root = window.Shopify?.routes?.root || labels.root || '/';
    const badge = document.getElementById('pdp-cart-count');
    const loadCart = async () => {
      const response = await fetch(root + 'cart.js');
      if (!response.ok) throw new Error('Cart unavailable');
      const cart = await response.json();
      badge.textContent = cart.item_count;
      badge.style.display = cart.item_count ? 'flex' : 'none';
      return cart;
    };
    loadCart().catch(() => {});
    document.addEventListener('cart:updated', () => loadCart().catch(() => {}));
    document.addEventListener('zenx:cart-updated', e => { badge.textContent=e.detail.itemCount; badge.style.display=e.detail.itemCount?'flex':'none'; });
    const dialog = document.getElementById('zenx-cart-dialog');
    dialog.querySelector('[data-close-cart]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', e => { if(e.target === dialog && e.clientX < dialog.getBoundingClientRect().left) dialog.close(); });
    document.querySelector('.pdp-header-cart').addEventListener('click', async e => {
      e.preventDefault();
      if (window.ZenxCart) { window.ZenxCart.open(); return; }
      if (typeof window.openHeaderCart === 'function') { window.openHeaderCart(); return; }
      const area = dialog.querySelector('.zenx-cart-items');
      area.replaceChildren();
      dialog.showModal();
      try {
        const cart = await loadCart();
        const money = amount => new Intl.NumberFormat(document.documentElement.lang || 'fr', {style:'currency',currency:cart.currency || labels.currency || 'EUR'}).format(amount/100);
        if (!cart.item_count) { const p = document.createElement('p'); p.textContent=labels.empty; area.append(p); }
        cart.items.forEach(item => {
          const article = document.createElement('article'), title = document.createElement('strong'), details = document.createElement('span');
          title.textContent=item.product_title; details.textContent=`${item.quantity} × ${money(item.final_price)}`; article.append(title,details); area.append(article);
        });
        if(cart.item_count){const p=document.createElement('p');p.textContent=labels.total+' : '+money(cart.total_price);area.append(p);}
        dialog.querySelector('[data-checkout]').hidden=!cart.item_count;
      } catch { area.textContent=labels.error; }
    });
  }
  init();
  document.addEventListener('shopify:section:load', init);
})();
